import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            // flexGrow: 10,
            margin: '1rem 0',
            marginBottom: '1.5625rem',
            paddingRight: '1rem',
            '& h4': {
                fontSize: '1.2143rem',
                color: '#616161',
                margin: '0',
                fontWeight: '600',
                marginBottom: '0.625rem',
            },
            '& p': {
                fontSize: '1.07143rem',
                color: '#8D98B7',
                margin: '0',
                fontWeight: '400',
            },
        },
    }),
);

interface IFormAlongSideTextProps {
    label: string;
    secondLabel?: string;
    secondLabelJSX?: JSX.Element;
}

const FormAlongsideText = ({ label, secondLabel, secondLabelJSX }: IFormAlongSideTextProps) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <h4>{t(label)}</h4>

            {secondLabel && <p>{!secondLabel ? '' : !secondLabelJSX ? t(secondLabel) : secondLabelJSX}</p>}
        </div>
    );
};

export default FormAlongsideText;
